import { createRouter, createWebHistory } from "vue-router";
import auth from "./auth.middlware.js";
import auth2 from "./auth2.middlware.js";
import store from "../store";

// import MessageUser from '../components/taxi/MessageUser.vue';
import receiptUser from "../components/taxi/receiptUser.vue";
import serviceArchieve from "../components/taxi/serviceArchieve.vue";
import creditUser from "../components/taxi/creditUser.vue";
import detailService from "../components/taxi/serviceDetail.vue";
import currentService from "../components/taxi/currentService.vue";
import manualService from "../components/taxi/manualService.vue";
import waiting_driver from "../components/taxi/waiting_driver.vue";

const routes = [
  {
    path: "/login",
    name: "loginPage",
    component: () => import("../views/login.vue"),
    // meta: {
    //     middleware: [auth],
    // },
  },
  {
    path: "/",
    name: "firstPage",
    component: () => import("../views/firstPage"),
    meta: {
      middleware: [auth],
    },
    beforeEnter: (to, from, next) => {
      if (store.state.device == "Desktop") {
        next("/desktop");
      } else {
        next();
      }
    },
  },

  {
    path: "/desktop",
    name: "firstPageDesktop",
    component: () => import("../views/firstPageDesktop"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/profile",
    name: "profileUser",
    component: () => import("../views/profile.vue"),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: "/shop",
    component: () => import("@/layout/StoreLayout.vue"),
    children: [
      {
        path: "mobile",
        name: "HomePage",
        component: () => import("../views/MobileHome.vue"),
        meta: {
          middleware: [auth],
        },
        beforeEnter: (to, from, next) => {
          if (store.state.device == "Desktop") {
            next("/shop/home");
          } else {
            next();
          }
        },
      },

      {
        path: "home",
        name: "DesktopHome",
        component: () => import("../views/DekstopHome.vue"),
        meta: {
          middleware: [auth],
        },
      },

      {
        path: "landing-page",
        name: "landingPage",
        component: () => import("../views/landingPage.vue"),
      },
      {
        path: "shops",
        name: "ShopList",
        component: () => import("../views/ShopList"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "add",
        name: "addStore",
        component: () => import("../views/addStore.vue"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "edit",
        name: "editPage",
        props: (route) => ({
          detail: "",
          ...route.params,
        }),
        component: () => import("../views/edit.vue"),
        meta: {
          middleware: [auth],
        },
      },

      {
        path: "edit-store",
        name: "editStore",
        component: () => import("../views/editStore.vue"),
        meta: {
          middleware: [auth],
        },
      },

      {
        path: "mystore-profile/:upload?",
        name: "myStoreProfile",
        component: () => import("../views/mystoreProfile.vue"),
        meta: {
          middleware: [auth],
        },
      },

      {
        path: "store-profile",
        name: "storeProfile",
        component: () => import("../views/storeProfile.vue"),
        meta: {
          middleware: [auth],
        },
      },

      {
        path: "favorite",
        name: "favoritePage",
        component: () => import("../views/favorite.vue"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "create-product",
        name: "CreateProdcut",
        component: () => import("../views/CreateProdcut"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "detail",
        name: "DetailPoduct",
        component: () => import("../views/Detail"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "edit-product",
        name: "editProdcut",
        component: () => import("../views/EditProdcut"),
        meta: {
          middleware: [auth],
        },
      },

      {
        path: "credit",
        name: "userCredit",
        component: () => import("../views/creditUser"),
        meta: {
          middleware: [auth],
        },
      },

      {
        path: "basket",
        name: "basketUser",
        component: () => import("../views/basket"),
        // meta: {
        //   middleware: [auth],
        // },
      },
      {
        path: "explore",
        name: "ExploreView",
        component: () => import("../views/explore.vue"),
        meta: {
          middleware: [auth],
        },
      },
      {
        path: "about/:id",
        name: "about-us",
        component: () => import("../views/About-us.vue"),
        props: true,
        meta: { paramName: "paramValue" },
      },
      {
        path: "order-list-store",
        name: "OrderListStore",
        component: () => import("../views/orderListStore.vue"),
        meta: { middleware: [auth] },
      },
      {
        path: "order-list",
        name: "OrderList",
        component: () => import("../views/orderList.vue"),
        meta: { middleware: [auth] },
      },
      {
        path: "buy-subscribtion",
        name: "buySubscribtion",
        component: () => import("../views/buySubscribtion.vue"),
        meta: { middleware: [auth] },
      },
      {
        path: "chat",
        name: "chatSystem",
        component: () => import("../views/chatSystem.vue"),
        meta: { middleware: [auth] },
      },
    ],
  },
  {
    path: "/taxi",
    component: () => import("@/layout/TaxiLayout.vue"),
    children: [
      {
        path: "manualService",
        name: "manualService",
        component: manualService,
        meta: {
          middleware: [auth2],
        },
      },

      // {
      //     path: 'message',
      //     name: 'MessageUser',
      //     component: MessageUser,
      //     meta: {
      //         middleware: [auth]
      //     }
      // },
      {
        path: "receipt",
        name: "receiptUser",
        component: receiptUser,
        meta: {
          middleware: [auth2],
        },
      },
      {
        path: "serviceArchieve",
        name: "serviceArchieve",
        component: serviceArchieve,
        meta: {
          middleware: [auth2],
        },
      },
      {
        path: "credit",
        name: "creditUser",
        component: creditUser,
        meta: {
          middleware: [auth2],
        },
      },
      {
        path: "servicedetail/:id",
        name: "detailService",
        component: detailService,
        meta: {
          middleware: [auth2],
        },
      },

      {
        path: "currentservice",
        name: "currentService",
        component: currentService,
        meta: {
          middleware: [auth2],
        },
      },
      {
        path: "waiting-driver",
        name: "waiting_driver",
        component: waiting_driver,
        meta: {
          middleware: [auth2],
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  const context = {
    to,
    from,
    next,
    store,
  };
  return to.meta.middleware[0]({
    ...context,
  });
});

export default router;
